/**
 * @overview
 * A higher order component that redirects to the login page when no session is found.
 * Note: the UserContextProvider handles session loading and error states before this renders
 */

import React from 'react'
import { browserHistory } from 'react-router'
import { compose } from 'recompose'
import { Pane, Spinner, majorScale } from 'evergreen-ui'
import { withUserContext } from '../context/UserContext'
import { loginPath } from 'lib/path-helpers'
import getDisplayName from 'lib/get-display-name'

function LoadingPlaceholder() {
  return (
    <Pane display="flex">
      <Spinner
        size={majorScale(3)}
        flexBasis={majorScale(3)}
        marginY={majorScale(8)}
        marginX="auto"
      />
    </Pane>
  )
}

function withSessionRequired(Component) {
  return class WithSessionRequired extends React.Component {
    static displayName = `WithSessionRequired(${getDisplayName(Component)})`

    componentDidMount() {
      if (!this.props.user) {
        browserHistory.push(
          loginPath({
            query: {
              redirect: window.location.pathname + window.location.search
            }
          })
        )
      }
    }

    render() {
      if (this.props.user) {
        // Pass down `user` from `withUserContext` along with all other props
        return <Component {...this.props} />
      }

      return <LoadingPlaceholder />
    }
  }
}

export default compose(
  withUserContext,
  withSessionRequired
)
